import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainBoardComponent } from './main-board/main-board.component';
import { WebViewerFrameComponent } from './web-viewer-frame/web-viewer-frame.component';
import { UploadPatientMRNComponent } from './upload-patient-mrn/upload-patient-mrn.component';


const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: '/login' },

  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then(x => x.LoginModule)
  },
  /* {
    path: 'WebViewer/:id',
    component: WebViewerFrameComponent
  }, */
  {
    path: 'WebViewer',
    component: WebViewerFrameComponent
  },
  {
    path: 'mainboard',
    component: MainBoardComponent,
    children: [
      {
        path: 'patientList',
        loadChildren: () => import('./patient-list-screen/patient-list-screen-routing.module').then(x => x.PatientListScreenRoutingModule)
      },
      {
        path: 'users',
        loadChildren: () => import('./users/users-routing.module').then(x => x.UsersRoutingModule)
      },
      {
        path: 'configure',
        component: UploadPatientMRNComponent
      },
      {
        path: 'aboutPatient',
        loadChildren: () => import('./about-patient-screen/about-patient-screen-routing.module').then(x => x.AboutPatientScreenRoutingModule)
      },
      {
        path: 'patientImages',
        loadChildren: () => import('./patient-images-screen/patient-images-screen-routing.module').then(x => x.PatientImagesScreenRoutingModule)
      },
      {
        path: 'reports/:id',
        loadChildren: () => import('./reports-screen/reports-screen-routing.module').then(x => x.ReportsScreenRoutingModule)
      },
      {
        path: 'patientGallery/:id',
        loadChildren: () => import('./patient-gallery-screen/patient-gallery-screen.module').then(m => m.PatientGalleryScreenModule)
      },
      //addtional routing component
      {

        path: 'patient-data/:id',
        loadChildren: () => import('./about-patient-data-screen/about-patient-data-screen.module').then(x => x.AboutPatientDataScreenModule)
      },
      //  {
      //   path:'sample-report',
      //   loadChildren:() => import('./sample-report-screen/sample-report-screen-routing/sample-report-screen-routing.module').then(x=>x.SampleReportScreenRoutingModule)
      //  }
    ]
    // loadChildren: () => import('./main-board/main-board.module').then(x => x.MainBoardModule)
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
